// import { DOCUMENT } from '@angular/common';
import { CommonModule, isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Component, Inject, PLATFORM_ID, makeStateKey } from '@angular/core';
import { PrerenderDataService } from '../../prerender-data.service';
import { Category, ItemService } from '../../pages/item-detail/item-detail.service';
import { RouterModule } from '@angular/router';
import { LogocComponent } from './logoc/logoc.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule, LogocComponent],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  GET_ALL_CATS = makeStateKey<any>('GET_ALL_CATS_FOOTER');
  cats: Category[][] = [[]];
  ver = ''
  // cats: Category[] = [];
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private itemsService: ItemService,
    private prerenderDataService: PrerenderDataService) {
    if (isPlatformServer(platformId)) {

      prerenderDataService.setPreloadedData(makeStateKey<any>('VER'), this.generateUniqueCode())
      this.ver = prerenderDataService.getPreloadedData(makeStateKey<any>('VER'))
      itemsService.getAllCats().subscribe(e => {
        prerenderDataService.setPreloadedData(this.GET_ALL_CATS, e);
        const g = prerenderDataService.getPreloadedData(this.GET_ALL_CATS);
        if (g !== null)
          this.cats = this.chunk(prerenderDataService.getPreloadedData(this.GET_ALL_CATS), 9);
      })

    } else {
      const g = prerenderDataService.getPreloadedData(this.GET_ALL_CATS);
      if (g !== null)
        this.cats = this.chunk(prerenderDataService.getPreloadedData(this.GET_ALL_CATS), 9);
    }
    if (isPlatformBrowser(platformId)) {
      this.ver = prerenderDataService.getPreloadedData(makeStateKey<any>('VER'))

    }


  }

  generateUniqueCode() {
    const now = new Date();
    const hour = now.getHours().toString().padStart(2, '0');
    const minute = now.getMinutes().toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');
    const year = now.getFullYear().toString();

    return `${hour}${minute}h${day}${month}${year}`;
  }

  chunk = (arr: Category[], size: number) =>
    Array.from({ length: Math.ceil(arr.length / size) }, (v, i) =>
      arr.slice(i * size, i * size + size)
    );

}
